import React from 'react';

import WpEmoji from '../WpEmoji';
import WpEmojiPicker from '../WpEmojiPicker';

const EmojiDocs = () => {
  return (
    <>
      <WpEmojiPicker />
      <WpEmoji emoji=":smile:" />
    </>
  );
};

export default EmojiDocs;
